import { render, staticRenderFns } from "./isPro3.vue?vue&type=template&id=28b688ae&scoped=true&"
import script from "./isPro3.vue?vue&type=script&lang=js&"
export * from "./isPro3.vue?vue&type=script&lang=js&"
import style0 from "./isPro3.vue?vue&type=style&index=0&id=28b688ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b688ae",
  null
  
)

export default component.exports